import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "expenseGroupIdField", "bulkUpdateControls"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(c => c.checked)
    const expenseGroupIds = checked.map(checkbox => checkbox.value)
    this.expenseGroupIdFieldTarget.value = expenseGroupIds.join(",")

    if(expenseGroupIds.length) {
      showTarget(this.bulkUpdateControlsTarget)
    }
    else {
      hideTarget(this.bulkUpdateControlsTarget)
    }
  }

  hideAllCheckboxes() {
    hideTarget(this.checkboxTargets)
  }
}
